import PropTypes from 'prop-types';
import React from 'react';
import Badge from './badge';

// Status badge component
const StatusBadge = ({
  status
}) => {
  const config = {
    passed: {
      color: 'success',
      icon: '✓',
      label: 'Passed'
    },
    failed: {
      color: 'danger',
      icon: '✕',
      label: 'Failed'
    },
    warning: {
      color: 'warning',
      icon: '⚠',
      label: 'Warning'
    },
    unknown: {
      color: 'secondary',
      icon: '?',
      label: 'Unknown'
    }
  };
  const {
    color,
    icon,
    label
  } = config[status] || config.unknown;
  return /*#__PURE__*/React.createElement(Badge, {
    tag: "span",
    color: color,
    pill: true,
    className: "quality-agent__status-badge"
  }, icon, " ", label);
};
StatusBadge.propTypes = {
  status: PropTypes.string.isRequired
};
export default StatusBadge;